import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { guest: true },
  },
  {
    path: '/tasks',
    name: 'Tasks',
    component: () => import('../views/Tasks.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/task-work',
    name: 'TaskWork',
    component: () => import('../views/TaskWork.vue'),
    meta: { requiresAuth: true, workerOnly: true },
  },
  {
    path: '/review-work',
    name: 'ReviewWork',
    component: () => import('../views/ReviewWork.vue'),
    meta: { requiresAuth: true, adminOnly: true },
  },
  {
    path: '/bills',
    name: 'Bills',
    component: () => import('../views/Bills.vue'),
    meta: { requiresAuth: true, reviewerForbidden: true },
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/Users.vue'),
    meta: { requiresAuth: true, superadminOnly: true },
  },
  {
    path: '/import/sku',
    name: 'SkuImport',
    component: () => import('../views/SkuImport.vue'),
    meta: { requiresAuth: true, adminOnly: true },
  },
  {
    path: '/import/pdf',
    name: 'PdfPipeline',
    component: () => import('../views/PdfPipeline.vue'),
    meta: { requiresAuth: true, adminOnly: true },
  },
  {
    path: '/import/price-check',
    name: 'PriceCheck',
    component: () => import('../views/PriceCheck.vue'),
    meta: { requiresAuth: true, adminOnly: true },
  },
  {
    path: '/',
    redirect: '/tasks',
  },
  {
    path: '*',
    redirect: '/tasks',
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn
  const isAdmin = store.getters.isAdmin
  const isSuperadmin = store.getters.isSuperadmin
  const isWorker = store.getters.isWorker
  const isReviewer = store.getters.isReviewer

  if (to.meta.requiresAuth && !isLoggedIn) {
    next('/login')
  } else if (to.meta.superadminOnly && !isSuperadmin) {
    next('/tasks')
  } else if (to.meta.adminOnly && !isAdmin) {
    next('/tasks')
  } else if (to.meta.workerOnly && !isWorker) {
    next('/tasks')
  } else if (to.meta.reviewerForbidden && isReviewer) {
    next('/tasks')
  } else if (to.meta.guest && isLoggedIn) {
    next('/tasks')
  } else {
    next()
  }
})

export default router
